import { FILE_CONTENT_TYPE } from 'constants/reports';
import { ENTITY_NAMES_BY_ID } from 'constants/common';

// UTILS
import { downloadFileFromBase64, intercom } from 'utils';

import {
  startLoading,
  stopLoading,
  receivedUserViewsSuccess,
  receivedUserViewsFail,
  receivedCreateViewSuccess,
  receivedCreateViewFail,
  receivedUpdateViewSuccess,
  receivedUpdateViewFail,
  receivedDeleteViewSuccess,
  receivedDeleteViewFail,
  receivedGetRecurringEmailsSuccess,
  receivedGetRecurringEmailsFail,
  receivedCreateRecurringEmailSuccess,
  receivedCreateRecurringEmailFail,
  receivedUpdateRecurringEmailSuccess,
  receivedUpdateRecurringEmailFail,
  receivedDeleteRecurringEmailSuccess,
  receivedDeleteRecurringEmailFail,
  receivedClearNotifications,
} from './actions';

import {
  query,
  create,
  update,
  rename,
  toggleDefault,
  destroy,
  processExportView,
  getRecurringEmails,
  saveRecurringEmail,
  removeRecurringEmail,
} from './resources';

/**
 * Gets the user views
 */
export const getUserViews = (id) => (dispatch) => {
  dispatch(startLoading());

  return query(id)
    .then((response) => {
      dispatch(receivedUserViewsSuccess(response));
      return response;
    })
    .catch((response) => {
      dispatch(receivedUserViewsFail(response));
    });
};

/**
 * Creates a new view
 */
export const createView = (name, rules, columns, owner, typeId) => (dispatch) => {
  dispatch(startLoading());

  return create(name, rules, columns, owner, typeId)
    .then((response) => {
      dispatch(receivedCreateViewSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedCreateViewFail(response));

      return Promise.reject();
    });
};

/**
 * Updates a view
 */
export const updateView = (id, rules, columns) => (dispatch) => {
  dispatch(startLoading());

  return (
    update(id, rules, columns)
      // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
      .then((response) => dispatch(receivedUpdateViewSuccess(response)))
      .catch((response) => {
        dispatch(receivedUpdateViewFail(response));

        return Promise.reject();
      })
  );
};

/**
 * Renames a view
 */
export const renameView = (id, name) => (dispatch) => {
  dispatch(startLoading());

  return (
    rename(id, name)
      // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
      .then((response) => dispatch(receivedUpdateViewSuccess(response)))
      .catch((response) => {
        dispatch(receivedUpdateViewFail(response));
      })
  );
};

/**
 * Makes a view default
 */
export const setDefaultView =
  (id, isDefault = true) =>
  (dispatch) => {
    dispatch(startLoading());

    return toggleDefault(id, isDefault)
      .then((response) => dispatch(receivedUpdateViewSuccess(response, !isDefault)))
      .catch((response) => {
        dispatch(receivedUpdateViewFail(response));
      });
  };

/**
 * Deletes a view
 */
export const deleteView = (id) => (dispatch) => {
  dispatch(startLoading());

  return destroy(id)
    .then(() => {
      dispatch(receivedDeleteViewSuccess(id));
    })
    .catch((response) => {
      dispatch(receivedDeleteViewFail(response));
    });
};

/**
 * Exports a view
 */
export const exportView = (id, name, entityTypeId, fileFormat, emails, filters) => (dispatch) => {
  dispatch(startLoading());

  intercom.trackEvent('Export view', {
    entity_type: ENTITY_NAMES_BY_ID[entityTypeId],
    export_type: emails ? 'email' : 'download',
  });

  return processExportView(id, entityTypeId, emails, filters)
    .then((response) => {
      dispatch(stopLoading());

      if (!emails) {
        downloadFileFromBase64(response, name, FILE_CONTENT_TYPE[fileFormat]);
      }
    })
    .catch(() => {
      dispatch(stopLoading());

      return Promise.reject();
    });
};

/**
 * Gets the email reports list
 */
export const getEmailReports = () => (dispatch) => {
  dispatch(startLoading());

  return getRecurringEmails()
    .then((response: any) => {
      dispatch(receivedGetRecurringEmailsSuccess(response.results));
    })
    .catch((response) => {
      dispatch(receivedGetRecurringEmailsFail(response));
    });
};

/**
 * Creates a new recurring email
 */
export const createRecurringEmail = (recurringEmail) => (dispatch) => {
  dispatch(startLoading());

  // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
  return saveRecurringEmail(recurringEmail)
    .then((response) => {
      dispatch(receivedCreateRecurringEmailSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedCreateRecurringEmailFail(response));

      return Promise.reject();
    });
};

/**
 * Updates a new recurring email
 */
export const updateRecurringEmail = (id, recurringEmail) => (dispatch) => {
  dispatch(startLoading());

  return saveRecurringEmail(recurringEmail, id)
    .then((response) => {
      dispatch(receivedUpdateRecurringEmailSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedUpdateRecurringEmailFail(response));

      return Promise.reject();
    });
};

/**
 * Deletes a recurring email
 */
export const deleteRecurringEmail = (id) => (dispatch) => {
  dispatch(startLoading());

  return removeRecurringEmail(id)
    .then(() => {
      dispatch(receivedDeleteRecurringEmailSuccess(id));
    })
    .catch((errors) => {
      dispatch(receivedDeleteRecurringEmailFail(errors));

      return Promise.reject();
    });
};

export const clearNotifications = () => (dispatch) => dispatch(receivedClearNotifications());
